export default __webpack_public_path__ + "static/media/316.ae893ea9.gif";